module.exports = __webpack_public_path__ + "arrow-right-white.45024af5555dda0727f6ba81e5add74d.svg";